import { ORIGIN, CRM } from '../env';

export function welcomeTemplate(fullName, username, password) {
  return `<mjml>
  <mj-body background-color="#ffffff">
    <mj-section background-color="#ffffff" padding-bottom="0px" padding-top="0">
      <mj-column vertical-align="top" width="100%">
        <mj-image src="https://email-attachments-public.s3.us-east-2.amazonaws.com/rs.png" alt="" align="center" border="none" width="120px" padding-left="0px" padding-right="0px" padding-bottom="0px" padding-top="0"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#009aca" padding-bottom="0px" padding-top="0px">
      <mj-column vertical-align="top" width="100%">
        <mj-text align="left" color="#ffffff" font-size="45px" font-weight="bold" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px" padding-bottom="30px" padding-top="50px">
          Welcome aboard
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#009aca" padding-bottom="20px" padding-top="20px">
      <mj-column vertical-align="middle" width="100%">
        <mj-text align="left" color="#ffffff" font-size="22px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">
          <span style="color:#FEEB35">Dear ${fullName || 'Member'}</span>
          <br /><br />
          Welcome to ReadySpaces.
        </mj-text>
        <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">
          <p>
            We are looking forward to have you as part of our community.
            You can login to your new ReadySpaces account with the following information:
            <li>
              Email: ${username}
            </li>
            <li>
              Temporary Password: ${password}
            </li>
          </p>
          In case you have any questions, please reach out to your facility manager or support@readyspaces.com.
        </mj-text>
        <mj-button href="${CRM}" align="left" font-size="22px" font-weight="bold" background-color="#ffffff" border-radius="10px" color="#1AA0E1" font-family="open Sans Helvetica, Arial, sans-serif">Login</mj-button>
        <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">Thanks, <br /> The Readyspaces Team</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`;
}

export function resetManagerTemplate(fullName, username, password) {
  return `<mjml>
  <mj-body background-color="#ffffff">
    <mj-section background-color="#ffffff" padding-bottom="0px" padding-top="0">
      <mj-column vertical-align="top" width="100%">
        <mj-image src="https://email-attachments-public.s3.us-east-2.amazonaws.com/rs.png" alt="" align="center" border="none" width="120px" padding-left="0px" padding-right="0px" padding-bottom="0px" padding-top="0"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#009aca" padding-bottom="0px" padding-top="0px">
      <mj-column vertical-align="top" width="100%">
        <mj-text align="left" color="#ffffff" font-size="45px" font-weight="bold" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px" padding-bottom="30px" padding-top="50px">Temp Password Set</mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#009aca" padding-bottom="20px" padding-top="20px">
      <mj-column vertical-align="middle" width="100%">
        <mj-text align="left" color="#ffffff" font-size="22px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px"><span style="color:#FEEB35">Dear ${fullName}</span><br /><br /> We are your back at Readyspaces.</mj-text>
        <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">You can login to your account with your email ${username} and password ${password}.</mj-text>
        <mj-button href="${ORIGIN}" align="left" font-size="22px" font-weight="bold" background-color="#ffffff" border-radius="10px" color="#1AA0E1" font-family="open Sans Helvetica, Arial, sans-serif">Login</mj-button>
        <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">Thanks, <br /> The Readyspaces Team</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`;
}

export function resetTemplate(fullName) {
  return `<mjml>
  <mj-body>
    <mj-section>
      <mj-column>

        <mj-image width="100px" src="https://email-attachments-public.s3.us-east-2.amazonaws.com/rs.png"></mj-image>

        <mj-divider border-color="#F45E43"></mj-divider>

        <mj-text font-size="20px" color="#009aca" font-family="helvetica">Dear ${fullName},
        </mj-text>

                <mj-text font-size="15px" color="#009aca" font-family="helvetica">Please sign up on our secured CRM.
        </mj-text>
        <mj-button href="${CRM}">
                  Sign Up
                  </mj-button>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`;
}

export function unitEmailV2Template(memberName, facilityName, facilityAddressInfo, unit, manager, tags, price, currencySign, computedSecurityFee, taxEnabled, taxLabel) {

  const imageRows = [];
  for (let i = 0; i < unit.images.length; i += 2) {
    imageRows.push({
      image1: unit.images[i],
      image2: unit.images[i + 1] || null
    });
  }
  const gQuery = `ReadySpaces ${facilityAddressInfo.addressLine1}`;
  let unitImages = '';
  let unitTags = '';
  const unitRate = `<span class="price-large" style="font-size: 42px; display: inline-block;">${Number(price).toLocaleString('en', { style: 'currency', currency: currencySign })}</span><span class="price-small" style="font-size: 20px; display: inline-block;">/month</span>${taxEnabled && taxLabel ? `<span style="font-size: 12px; color: #666666;"> + ${taxLabel}</span>` : ''}`;
  for ( const tag of tags ) {
    unitTags += `
    <mj-text padding-bottom="8px">
      <div style="background-color: #ffffff; padding: 12px; border-radius: 8px; border-left: 4px solid #009aca;">
        <div style="margin: 0; color: #000000; font-size: 15px;">
          ${tag}
        </div>
      </div>
    </mj-text>`;
  }

  for ( const unitImageRow of imageRows ) {
    unitImages += `<mj-section padding="0">
        <mj-group>
          <mj-column width="50%">
            <mj-image 
              src="${unitImageRow.image1.url}"
              alt="${unitImageRow.image1.name}"
              border-radius="8px"
              padding="3px"
            />
          </mj-column>
          ${unitImageRow.image2 ? `
            <mj-column width="50%">
              <mj-image 
                src="${unitImageRow.image2.url}"
                alt="${unitImageRow.image2.name}"
                border-radius="8px"
                padding="3px"
              />
            </mj-column>
            ` : ''}
        </mj-group>
      </mj-section>`;
  }

  return `<mjml>
    <mj-head>
      <mj-style>
        @media only screen and (max-width: 480px) {
          .price-large {
            font-size: 32px !important;
          }
          .price-small {
            font-size: 16px !important;
          }
          .facility-title {
            font-size: 18px !important;
          }
          .mobile-text-16 {
            font-size: 16px !important;
          }
          .mobile-text-14 {
            font-size: 14px !important;
          }
          .mobile-text-13 {
            font-size: 13px !important;
          }
          .mobile-text-12 {
            font-size: 12px !important;
          }
          .mobile-text-18 {
            font-size: 18px !important;
          }
          .mobile-button {
            font-size: 16px !important;
            padding: 12px 25px !important;
          }
          .logo-image {
            width: 250px !important;
            max-width: 100% !important;
          }
        }
      </mj-style>
    </mj-head>
    <mj-body background-color="#ffffff">

      <mj-section padding="0" background-color="#ffffff">
        <mj-column vertical-align="top" width="100%">
          <mj-image 
            src="https://email-attachments-public.s3.us-east-2.amazonaws.com/rs.png"
            alt="ReadySpaces Logo"
            border="none" width="120px" padding-left="0px" padding-right="0px" padding-bottom="0px" padding-top="0"
            href="https://readyspaces.com?utm_source=email&utm_medium=email&utm_campaign=space_pricing"
            align="center"
            css-class="logo-image"
          />
        </mj-column>
      </mj-section>

      <mj-section padding="15px 15px" background-color="#ffffff">
        <mj-column>
          <mj-text font-size="18px" line-height="1.4" padding-bottom="0" color="#000000" css-class="mobile-text-16">
            <strong>Hi ${memberName},</strong>
            <p style="margin: 12px 0 8px 0;">Here's the unit we talked about — I think it could be a great fit for your team.</p>
            <p style="margin: 0;">Take a look at the details below, and let me know your thoughts!</p>
          </mj-text>
        </mj-column>
      </mj-section>

      <mj-wrapper background-color="#f8f8f8" border-radius="10px" padding="15px" padding-bottom="15px" padding-top="15px" padding-left="15px" padding-right="15px">
        
        <mj-section padding="0" padding-bottom="12px">
          <mj-column>
            <mj-text align="center" padding="0">
              <div class="facility-title" style="font-size: 22px; color: #000000; font-weight: bold; margin-bottom: 6px; line-height: 1.3;">${facilityName} - ${unit.name} - ${unit.computedSize} sq ft</div>
            </mj-text>
          </mj-column>
        </mj-section>
        ${unitImages}

        <!--
        <mj-section padding="15px 0 0">
          <mj-column>
            <mj-text align="center" padding="0">
              <a href="{{VIRTUAL_TOUR_URL}}" style="color: #009aca; font-size: 16px; font-weight: bold; text-decoration: underline;">Take a 3D Virtual Tour →</a>
            </mj-text>
          </mj-column>
        </mj-section>
        -->
        <mj-section padding="12px 0 0">
          <mj-column>
            <mj-text padding="0">
              <div style="background-color: #ffffff; padding: 15px; border-radius: 8px; border: 2px solid #009aca;">
                <div style="font-size: 17px; font-weight: bold; color: #000000; margin-bottom: 6px; text-align: center; line-height: 1.3;">📍 Facility Location</div>
                <div style="font-size: 15px; color: #000000; line-height: 1.4; text-align: center; word-wrap: break-word;">
                  ${facilityAddressInfo && facilityAddressInfo.addressLine1 ? facilityAddressInfo.addressLine1 : ''}
                  ${facilityAddressInfo && facilityAddressInfo.addressLine2 ? facilityAddressInfo.addressLine2 : ''}<br />
                  ${facilityAddressInfo.city}, ${facilityAddressInfo.state}, ${facilityAddressInfo.pinCode}<br />
                </div>
                <div style="margin-top: 10px; text-align: center;">
                  <a href="https://www.google.com/maps/search/?api=1&query=${gQuery}" style="color: #009aca; font-size: 14px; font-weight: bold; text-decoration: underline;">View on Map →</a>
                </div>
              </div>
            </mj-text>
          </mj-column>
        </mj-section>

      </mj-wrapper>

      <mj-wrapper background-color="#CDF6FF" border-radius="10px" border="2px solid #009aca" padding="15px" padding-bottom="15px" padding-top="15px" padding-left="15px" padding-right="15px">
        
        <mj-section padding="20px 20px 12px" padding-left="15px" padding-right="15px">
          <mj-column>
            <mj-text align="center" padding-bottom="0">
              <div style="font-size: 15px; color: #7b7b7b; margin: 0 0 8px 0; line-height: 1.3;">Your All-Inclusive Monthly Rate</div>
              <div style="font-size: 42px; color: #009aca; margin: 0; font-weight: bold; line-height: 1.2;">
                ${unitRate}
              </div>
              ${computedSecurityFee && computedSecurityFee.fee ? `
              <div style="font-size: 14px; color: #7b7b7b; margin: 8px 0 0 0; line-height: 1.3;">${computedSecurityFee.label || 'Security'} Fee: ${Number(computedSecurityFee.fee).toLocaleString('en', { style: 'currency', currency: currencySign })}</div>
              ` : ''}
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section padding="0 20px" padding-left="15px" padding-right="15px">
          <mj-column>
            <mj-divider border-color="#009aca" border-width="2px" padding="12px 0" />
          </mj-column>
        </mj-section>

        <mj-section padding="0 20px 12px" padding-left="15px" padding-right="15px">
          <mj-column>
            <mj-text align="center" padding="0">
              <div style="font-size: 17px; font-weight: bold; color: #000000; margin-bottom: 12px; line-height: 1.3;">Everything You Need, Included:</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section padding="0 20px 20px" padding-left="15px" padding-right="15px" background-color="#CDF6FF">
          <mj-group>
            <mj-column width="50%">
              <mj-text padding-right="8px" padding-left="0" padding="0">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-bottom: 8px;">
                  <tr>
                    <td bgcolor="#ffffff" style="background-color: #ffffff; padding: 10px; border-radius: 8px; border-left: 4px solid #009aca; mso-border-radius: 8px;">
                      <span style="color: #000000; font-size: 14px; font-weight: bold;">✓ Base Rent</span>
                    </td>
                  </tr>
                </table>
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-bottom: 8px;">
                  <tr>
                    <td bgcolor="#ffffff" style="background-color: #ffffff; padding: 10px; border-radius: 8px; border-left: 4px solid #009aca; mso-border-radius: 8px;">
                      <span style="color: #000000; font-size: 14px; font-weight: bold;">✓ All Utilities</span>
                    </td>
                  </tr>
                </table>
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-bottom: 8px;">
                  <tr>
                    <td bgcolor="#ffffff" style="background-color: #ffffff; padding: 10px; border-radius: 8px; border-left: 4px solid #009aca; mso-border-radius: 8px;">
                      <span style="color: #000000; font-size: 14px; font-weight: bold;">✓ WiFi</span>
                    </td>
                  </tr>
                </table>
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
                  <tr>
                    <td bgcolor="#ffffff" style="background-color: #ffffff; padding: 10px; border-radius: 8px; border-left: 4px solid #009aca; mso-border-radius: 8px;">
                      <span style="color: #000000; font-size: 14px; font-weight: bold;">✓ Maintenance & Janitorial</span>
                    </td>
                  </tr>
                </table>
              </mj-text>
            </mj-column>
            <mj-column width="50%">
              <mj-text padding-left="8px" padding-right="0" padding="0">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-bottom: 8px;">
                  <tr>
                    <td bgcolor="#ffffff" style="background-color: #ffffff; padding: 10px; border-radius: 8px; border-left: 4px solid #009aca; mso-border-radius: 8px;">
                      <span style="color: #000000; font-size: 14px; font-weight: bold;">✓ Waste Management</span>
                    </td>
                  </tr>
                </table>
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-bottom: 8px;">
                  <tr>
                    <td bgcolor="#ffffff" style="background-color: #ffffff; padding: 10px; border-radius: 8px; border-left: 4px solid #009aca; mso-border-radius: 8px;">
                      <span style="color: #000000; font-size: 14px; font-weight: bold;">✓ *Forklift Access</span>
                    </td>
                  </tr>
                </table>
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-bottom: 8px;">
                  <tr>
                    <td bgcolor="#ffffff" style="background-color: #ffffff; padding: 10px; border-radius: 8px; border-left: 4px solid #009aca; mso-border-radius: 8px;">
                      <span style="color: #000000; font-size: 14px; font-weight: bold;">✓ Loading Dock</span>
                    </td>
                  </tr>
                </table>
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
                  <tr>
                    <td bgcolor="#ffffff" style="background-color: #ffffff; padding: 10px; border-radius: 8px; border-left: 4px solid #009aca; mso-border-radius: 8px;">
                      <span style="color: #000000; font-size: 14px; font-weight: bold;">✓ On-Site Management</span>
                    </td>
                  </tr>
                </table>
              </mj-text>
            </mj-column>
          </mj-group>
        </mj-section>

      </mj-wrapper>

      ${tags && tags.length > 0 ? `
      <mj-section background-color="#CDF6FF" border-radius="10px" padding="15px">
        <mj-column>
          <mj-text align="center" padding-bottom="10px">
            <div style="font-size: 18px; font-weight: bold; color: #000000; line-height: 1.3;">Unit-Specific Features</div>
          </mj-text>
          ${unitTags}
        </mj-column>
      </mj-section>
      ` : ''}

      <mj-section background-color="#f8f8f8" border-radius="8px" padding="15px">
        <mj-column>
          <mj-text font-size="14px" line-height="1.5" color="#000000" css-class="mobile-text-14">
            <div style="font-weight: bold; margin-bottom: 8px; font-size: 15px; line-height: 1.3;">Important to Know:</div>
            <div style="line-height: 1.5;">• <strong>Liability Insurance Required:</strong>
              All members are required to carry a general liability insurance policy — this is standard for any commercial warehouse space.
            </div>
          </mj-text>
        </mj-column>
      </mj-section>

      <mj-section padding="15px 0" padding-left="15px" padding-right="15px">
        <mj-column>
          <mj-text font-size="15px" line-height="1.5" color="#000000" css-class="mobile-text-14">
            With ReadySpaces, you'll enjoy <strong>predictable, all-inclusive monthly costs with no surprise fees</strong>. There are <strong> no CAM charges, no unexpected utility bills, and no vendor coordination hassles — </strong> just <strong> one simple payment </strong> that covers everything you need to operate your business smoothly.
          </mj-text>
        </mj-column>
      </mj-section>

      <mj-section background-color="#CDF6FF" border-radius="10px" padding="20px" padding-left="15px" padding-right="15px">
        <mj-column>
          <mj-text align="center" font-size="20px" font-weight="bold" padding-bottom="10px" color="#000000" css-class="mobile-text-18">
            Ready to See It in Person?
          </mj-text>

          <mj-text align="center" padding-bottom="15px" color="#000000" font-size="15px" line-height="1.4" css-class="mobile-text-14">
            I'm here to answer any questions you have about the space, pricing, or how ReadySpaces works.
          </mj-text>

          <mj-button 
            background-color="#ff3300"
            color="#ffffff"
            border-radius="5px"
            font-size="18px"
            font-weight="bold"
            href="https://calendly.com/d/cn5-qwk-yk7?utm_source=email&utm_medium=email&utm_campaign=space_pricing"
            padding="15px 35px"
            css-class="mobile-button"
          >
            Schedule a Tour
          </mj-button>

          <mj-text align="center" font-size="14px" color="#000000" padding-top="12px" css-class="mobile-text-13">
            Or simply reply to this email with any questions
          </mj-text>

        </mj-column>
      </mj-section>

      <mj-section padding="12px 0" padding-left="15px" padding-right="15px">
        <mj-column>
          <mj-text font-size="15px" line-height="1.4" color="#000000" css-class="mobile-text-14">
            <p style="margin: 0 0 8px 0;">Talk soon,</p>
            <p style="margin: 0; line-height: 1.5;"><strong>${manager.name}</strong><br/>
            ${manager.title}<br/>
            ${manager.email}<br/>
            801-810-2009</p>
          </mj-text>
        </mj-column>
      </mj-section>

      <mj-section background-color="#ffffff" padding="0 15px 10px">
        <mj-column>
          <mj-text align="center" font-size="12px" color="#666666" line-height="1.5" css-class="mobile-text-12">
            Pricing shown reflects current rates and availability, which are subject to change at any time. All stated unit sizes are approximate. *Excluding New York State locations, where alternate equipment is available.
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-body>
  </mjml>
`;
}

export function emailPhotosTemplate(facilityName, facilityAddressInfo, unit, manager, tags, price, currencySign, computedSecurityFee) {
  return `<mjml>
  <mj-body background-color="#ffffff">
    <mj-section background-color="#ffffff" padding-bottom="0px" padding-top="0">
      <mj-column vertical-align="top" width="100%">
        <mj-image src="https://email-attachments-public.s3.us-east-2.amazonaws.com/rs.png" alt="" align="center" border="none" width="120px" padding-left="0px" padding-right="0px" padding-bottom="0px" padding-top="0"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#009aca" padding-bottom="20px" padding-top="20px">
      <mj-column vertical-align="top" width="100%">
        <mj-text align="center" color="#ffffff" font-size="25px" font-weight="bold" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px" padding-bottom="30px" padding-top="50px">UNIT DETAILS</mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#009aca" padding-bottom="20px" padding-top="20px">
      <mj-column background-color="#ffffff" vertical-align="middle" width="500px">
        <mj-text align="left" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="35px" padding-right="25px">Facility name: ${facilityName}</mj-text>
        <mj-text align="left" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="35px" padding-right="25px">Unit name: ${unit.name}</mj-text>
        <mj-text align="left" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="35px" padding-right="25px">Unit size: ${unit.computedSize} sq ft</mj-text>
        ${price ? `<mj-text align="left" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="35px" padding-right="25px">Monthly Price: ${Number(price).toLocaleString('en', { style: 'currency', currency: currencySign })} </mj-text>` : ''}
        ${computedSecurityFee ? `<mj-text align="left" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="35px" padding-right="25px">Monthly ${computedSecurityFee.label || 'Security'} Fee: ${Number(computedSecurityFee.fee).toLocaleString('en', { style: 'currency', currency: currencySign })} </mj-text>` : ''}
        <mj-text align="left" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="35px" padding-right="25px">Unit Features: ${tags && tags.length ? tags : 'No Additional Features'}</mj-text>
        <mj-text align="left" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="35px" padding-right="25px">Address: ${facilityAddressInfo && facilityAddressInfo.addressLine1 ? facilityAddressInfo.addressLine1 : ''}, ${facilityAddressInfo && facilityAddressInfo.addressLine2 ? facilityAddressInfo.addressLine2 : ''} ${facilityAddressInfo && facilityAddressInfo.city ? facilityAddressInfo.city : ''} ${facilityAddressInfo && facilityAddressInfo.state ? facilityAddressInfo.state : ''} ${facilityAddressInfo && facilityAddressInfo.pinCode ? facilityAddressInfo.pinCode : ''}
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#009aca" padding-bottom="20px" padding-top="20px">
      <mj-column>
        ${manager.name && manager.phone ? `<mj-text align="left" color="#ffffff" line-height="1" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">
        In case you have any questions, feel free to reach out to ${manager.name} at ${manager.phone} or ${manager.email}.</mj-text>` : ''}
        <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">
          Pricing shown reflects current rates, which are subject to change at any time.
        </mj-text>
        <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">
          All unit sizes are approximate.
        </mj-text>
        <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px">Thanks, <br /> The ReadySpaces Team</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`;
}

export function invoiceTemplate(lease, lineItems, customer, facility) {
  const name = customer.primaryContact ? customer.primaryContact.name : 'Member';
  // const { start } = lease;
  // const startDate = new Date(start).toLocaleDateString('en-US');

  const prepareLineItems = () => {
    let table = '';
    lineItems.reverse().forEach((lineItem) => {
      const createdAt = new Date(lineItem.createdAt).toLocaleDateString('en-US');
      table += `<tr style="border-bottom:1px solid #ecedee;text-align:left;">
        <td> ${createdAt} </td>
        <td> ${lineItem.description} </td>
        <td> ${Number(lineItem.amount).toLocaleString('en', { style: 'currency', currency: facility.pricing.currency })} </td>
        <td> ${Number(lineItem.accountBalance).toLocaleString('en', { style: 'currency', currency: facility.pricing.currency })} </td>
      </tr>`;
    });

    return table;
  };

  return `<mjml>
   <mj-body background-color="#ffffff">
     <mj-section background-color="#ffffff" padding-bottom="0px" padding-top="0">
       <mj-column vertical-align="top" width="100%">
         <mj-image src="https://email-attachments-public.s3.us-east-2.amazonaws.com/rs.png"
           alt="" align="center" border="none" width="120px" padding-left="0px" padding-right="0px" padding-bottom="0px" padding-top="0">
         </mj-image>
       </mj-column>
     </mj-section>
     <mj-section background-color="#009aca" padding-bottom="0px" padding-top="0px">
     </mj-section>
     <mj-section background-color="#009aca" padding-bottom="20px" padding-top="20px">
       <mj-column vertical-align="middle" width="100%">
         <mj-text align="left" color="#ffffff" font-size="22px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px"><span>Dear ${name}</span></mj-text>
         <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px" line-height="1.3">
           Below is an account history of your current lease at ReadySpaces.</br>
           If you have any questions or need assistance, please contact us during normal business hours and we’ll be happy to help.</br>
         </mj-text>
         <mj-table table-layout="auto" color="#ffffff">
           <tr style="border-bottom:1px solid #ecedee;text-align:left;">
              <th>Date</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Account Balance</th>
           </tr>
           ${prepareLineItems()}
         </mj-table>
         <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px" line-height="1.3">
           Thanks so much! <br /><br></br>
           The ReadySpaces Team <br />
           ReadySpaces ${facility.title}<br />
           ${facility.addressInfo && facility.addressInfo.addressLine1 ? facility.addressInfo.addressLine1 : ''}
           ${facility.addressInfo && facility.addressInfo.addressLine2 ? facility.addressInfo.addressLine2 : ''}<br />
           ${facility.addressInfo.city}, ${facility.addressInfo.state}, ${facility.addressInfo.pinCode}<br />
           ${facility.manager.phone}
         </mj-text>
       </mj-column>
      </mj-section>
   </mj-body>
 </mjml>`;
}

export function currentInvoiceTemplate(lease, lineItems, customer, facility, period) {
  const name = customer.primaryContact ? customer.primaryContact.name : 'Member';
  // const { start } = lease;
  // const startDate = new Date(start).toLocaleDateString('en-US');

  const prepareLineItems = () => {
    let table = '';
    lineItems.reverse().forEach((lineItem) => {
      const createdAt = new Date(lineItem.period).toLocaleDateString('en-US');
      table += `<tr style="border-bottom:1px solid #ecedee;text-align:left;">
        <td> ${createdAt} </td>
        <td> ${lineItem.description} </td>
        <td> ${Number(lineItem.amount).toLocaleString('en', { style: 'currency', currency: facility.pricing.currency })} </td>
        <td> ${Number(lineItem.accountBalance).toLocaleString('en', { style: 'currency', currency: facility.pricing.currency })} </td>
      </tr>`;
    });

    return table;
  };

  return `<mjml>
   <mj-body background-color="#ffffff">
     <mj-section background-color="#ffffff" padding-bottom="0px" padding-top="0">
       <mj-column vertical-align="top" width="100%">
         <mj-image src="https://email-attachments-public.s3.us-east-2.amazonaws.com/rs.png"
           alt="" align="center" border="none" width="120px" padding-left="0px" padding-right="0px" padding-bottom="0px" padding-top="0">
         </mj-image>
       </mj-column>
     </mj-section>
     <mj-section background-color="#009aca" padding-bottom="0px" padding-top="0px">
     </mj-section>
     <mj-section background-color="#009aca" padding-bottom="20px" padding-top="20px">
       <mj-column vertical-align="middle" width="100%">
         <mj-text align="left" color="#ffffff" font-size="22px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px"><span>Dear ${name}</span></mj-text>
         <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px" line-height="1.3">
           Below is the invoice line items of your current lease for the period: ${period} at ReadySpaces.</br>
           If you have any questions or need assistance, please contact us during normal business hours and we’ll be happy to help.</br>
         </mj-text>
         <mj-table table-layout="auto" color="#ffffff">
           <tr style="border-bottom:1px solid #ecedee;text-align:left;">
              <th>Date</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Account Balance</th>
           </tr>
           ${prepareLineItems()}
         </mj-table>
         <mj-text align="left" color="#ffffff" font-size="15px" font-family="open Sans Helvetica, Arial, sans-serif" padding-left="25px" padding-right="25px" line-height="1.3">
           Thanks so much! <br /><br></br>
           The ReadySpaces Team <br />
           ReadySpaces ${facility.title}<br />
           ${facility.addressInfo && facility.addressInfo.addressLine1 ? facility.addressInfo.addressLine1 : ''}
           ${facility.addressInfo && facility.addressInfo.addressLine2 ? facility.addressInfo.addressLine2 : ''}<br />
           ${facility.addressInfo.city}, ${facility.addressInfo.state}, ${facility.addressInfo.pinCode}<br />
           ${facility.manager.phone}
         </mj-text>
       </mj-column>
      </mj-section>
   </mj-body>
 </mjml>`;
}



// WEBPACK FOOTER //
// ./src/utils/emailTemplates.js